import { indexBy, prop } from 'ramda'

export const useOccupancyFeeCarTypeEnum = () => {
  const statusEnum = {
    ALL: 0,
    CHARGING: 1,
    OIL: 2,
  }

  const data = [
    {
      id: 0,
      label: '全部',
    },
    {
      id: 1,
      label: '充電車',
    },
    {
      id: 2,
      label: '燃油車',
    },
  ]

  const byId = indexBy(x => x.id, data)

  return {
    data,
    byId,
    statusEnum,
  }
}

export const useOccupancyFeeRoundingMethodEnum = () => {
  // 費率計算方式1:無條件進位, 2:不採計 = ['1', '2']
  const statusEnum = {
    CHARGE: 1,
    NO_CHARGE: 2,
  }

  const data = [
    {
      id: 1,
      label: '無條件進位',
    },
    {
      id: 2,
      label: '不採計',
    },
  ]

  const byId = indexBy(x => x.id, data)

  return {
    data,
    byId,
    statusEnum,
  }
}

// order mgmt
// 訂單狀態

export const OrderStatusColors = {
  0: '##FFCC2B',
  1: '#fff',
}

export const useOrderStatusEnum = () => {
  const statusEnum = {
    PROCESSING: 0,
    FINISHED: 1,
  }

  const data = [
    {
      id: 0,
      label: '處理中',
    },
    {
      id: 1,
      label: '已完成',
    },
  ]

  const byId = indexBy(x => x.id, data)

  return {
    data,
    byId,
    statusEnum,
  }
}

export const OrderTypeColors = {
  0: '#fff',
  1: '#E17567',
  2: '#A1DDFF',
}

//  訂單類型:0:一般訂單 1:取消訂單 2:補單
export const useOrderTypeEnum = () => {
  const statusEnum = {
    GENERAL: 0,
    CANCEL: 1,
    REPLACEMENT: 2,
  }

  const data = [
    {
      id: 0,
      label: '一般',
    },
    {
      id: 1,
      label: '註銷',
    },
    {
      id: 2,
      label: '補單',
    },
  ]

  const byId = indexBy(x => x.id, data)

  return {
    data,
    byId,
    statusEnum,
  }
}

// 充電站類型: AC or DC
export const useChargePointTypeEnum = () => {
  const statusEnum = {
    AC: 'AC',
    DC: 'DC',
  }

  const data = [
    {
      id: 'AC',
      label: 'AC',
    },
    {
      id: 'DC',
      label: 'DC',
    },
  ]

  const byId = indexBy(prop('id'), data)

  return {
    data,
    byId,
    statusEnum,
  }
}

// consumptionType 消費項目:0:停車費, 1:充電費, 2:占用費
export const useConsumptionTypeEnum = () => {
  const statusEnum = {
    PARKING_FEE: 0,
    CHARGING_FEE: 1,
    OCCUPANCY_FEE: 2,
  }
  const data = [
    {
      id: 0,
      label: '停車',
    },
    {
      id: 1,
      label: '充電',
    },
    {
      id: 2,
      label: '車格占用',
    },
  ]
  const byId = indexBy(x => x.id, data)

  return {
    data,
    byId,
    statusEnum,
  }
}

// 點數扣抵

// paymentType 付款方式:0:未設定 1:信用卡 2:LINE PAY 3:APPLE PAY
export const usePaymentTypeEnum = () => {
  const statusEnum = {
    NOT_SET: 0,
    CREDIT_CARD: 1,
    LINE_PAY: 2,
    APPLE_PAY: 3,
  }

  const data = [
    {
      id: 0,
      label: '未設定',
    },
    {
      id: 1,
      label: '信用卡',
    },
    {
      id: 2,
      label: 'LINE PAY',
    },
    {
      id: 3,
      label: 'APPLE PAY',
    },
  ]

  const byId = indexBy(x => x.id, data)

  return {
    data,
    byId,
    statusEnum,
  }
}

//paymentStatus 	付費狀態:-1: 支付失敗, 0: 初始狀態, 5: 完成授權, 6: 完成充電支付, 7: 完成充電預付, 8: 完成請款
export const usePaymentStatusEnum = () => {
  const statusEnum = {
    FAILED: -1,
    INITIAL: 0,
    AUTHORIZED: 5,
    CHARGE_PAID: 6,
    CHARGE_PREPAID: 7,
    PAYMENT_PAID: 8,
  }

  const data = [
    {
      id: -1,
      label: '支付失敗',
    },
    {
      id: 0,
      label: '初始狀態',
    },
    {
      id: 5,
      label: '完成授權',
    },
    {
      id: 6,
      label: '完成充電支付',
    },
    {
      id: 7,
      label: '完成充電預付',
    },
    {
      id: 8,
      label: '完成請款',
    },
  ]

  const byId = indexBy(x => x.id, data)

  return {
    data,
    byId,
    statusEnum,
  }
}

export const useDemandResponseTypeEnum = ({
  isDesc = false,
}: {
  isDesc?: boolean
}) => {
  const data = [
    {
      id: 0,
      label: '平均限流',
      desc: '',
    },
    {
      id: 1,
      label: '排隊充電',
      desc: '',
    },
    {
      id: 2,
      label: '平均限流 > 排隊充電',
      desc: '',
    },
  ]

  const dataDesc = [
    {
      id: 0,
      label: '平均限流',
      desc: '︱依來車數平均功率比例，快充和慢充將同時降低充電百分比',
    },
    {
      id: 1,
      label: '排隊充電',
      desc: '︱依序提供來車最大充電功率，超約則排隊充電',
    },
    {
      id: 2,
      label: '平均限流 > 排隊充電',
      desc: '︱依來車數平均限流，當平均值低於設定比例時，進行排隊充電',
    },
  ]

  const byId = indexBy(x => x.id, data)

  return {
    data: isDesc ? dataDesc : data,
    byId,
  }
}

export const useOperationTypeEnum = () => {
  const statusEnum = {
    PUBLIC_CHARGING: 0,
    PUBLIC_CHARGING_OFFICE: 1,
    PRIVATE_CHARGING: 2,
  }

  const data = [
    {
      id: 0,
      label: '公辦民營',
    },
    {
      id: 1,
      label: '公辦公營',
    },
    {
      id: 2,
      label: '私有民營',
    },
  ]

  const byId = indexBy(x => x.id, data)

  return {
    data,
    byId,
    statusEnum,
  }
}

export const useAirportOccupancyFeeRoundingEnum = () => {
  const optionEnum = {
    ROUND_UP: 1,
    NO_CHARGE: 2,
  }
  const toStr = (enumVal: number) => {
    if (enumVal === optionEnum.ROUND_UP) {
      return '無條件進位'
    }
    if (enumVal === optionEnum.NO_CHARGE) {
      return '不採計'
    }
    return ''
  }
  return {
    optionEnum,
    toStr,
  }
}
